import 'slick-carousel/slick/slick.min';

const table_comparison = () => {
    if ( $('.table-comparison').length ) {
        let windowWidth = $(window).width();

        $('.table-comparison .dual-column-table').each(function() {
            let $table = $(this);

            if ( windowWidth >= 768 ) {
                setTableHeadItemsHeight($table);
            }

            $(window).resize(function() {
                windowWidth = $(window).width();

                setTableHeadItemsHeight($table);
            });

            // set item height once slider is initialized
            $(this).on('init', function(event, slick, direction){
                setTableHeadItemsHeight($table);
            });
        });

        function setTableHeadItemsHeight($table) {
            $table.find('.head-item').css('minHeight', '');
            let $leftHeadItem = $table.find('.head-item.left');
            let $rightHeadItem = $table.find('.head-item.right');
            let leftHeadItemHeight = $leftHeadItem.outerHeight();
            let rightHeadItemHeight = $rightHeadItem.outerHeight();

            if (leftHeadItemHeight !== rightHeadItemHeight) {
                if (leftHeadItemHeight > rightHeadItemHeight) {
                    $rightHeadItem.css('minHeight', leftHeadItemHeight);
                } else {
                    $leftHeadItem.css('minHeight', rightHeadItemHeight);
                }
            }
        }
    }
}

export default table_comparison;